import React from 'react';
import { graphql, withApollo } from 'react-apollo';

import {
  Input,
  Button,
  Select,
  Checkbox,
  Modal,
  Col,
  Row,
  DatePicker,
  notification,
} from 'antd/lib';
import moment from 'moment';
import * as Icons from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import Loading from '../../common/Loading';

const { TextArea } = Input;
const confirm = Modal.confirm;

import getCertificacionTraspasoPorId from '../../../graphql/querys/rrhh/getCertificacionTraspasoPorId.graphql';
import updateCertificacionTraspaso from '../../../graphql/mutations/rrhh/updateCertificacionTraspaso.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

@graphql(getUsuario)
@graphql(updateCertificacionTraspaso, {
  name: 'updateCertificacionTraspaso',
})
class EditarCertificacionTraspaso extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      certificacion: {},
      fechaDeste: '',
      fechaHasta: '',
      normativa: '',
      pagoViaticos: '',
    };

    this.props.client
      .query({
        query: getCertificacionTraspasoPorId,
        variables: {
          _id: this.props.match.params.id,
        },
      })
      .then(res => {
        let certificacion = res.data.getCertificacionTraspasoPorId;
        // console.log('CERT llega =>', certificacion);
        if (certificacion) {
          this.setState({
            ...this.state,
            loading: false,
            certificacion,
            fechaDesde: moment(certificacion.fechaDesde),
            fechaHasta: moment(certificacion.fechaHasta),
            normativa: certificacion.normativa,
            pagoViaticos: certificacion.pagoViaticos,
          });
        }
      })
      .catch(err => {
        console.log('Error en la busqueda de la certificacion');
        console.log(err);

        Modal.error({
          title: 'Error en la inicializacion del componente grafico',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  }

  handleSubmit = e => {
    e.preventDefault();
    let yo = this;
    confirm({
      title: '¿Realmente quiere editar y guardar?',
      content: `Al presionar aceptar se guardarán los nuevos datos para la certificación.`,
      onOk() {
        // si confirma llamo  a la funcion que se encarga de editar la certificacion
        yo.editarCertificacionTraspaso();
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  editarCertificacionTraspaso = () => {
    this.setState({
      ...this.state,
      loading: true,
    });

    const objUpdate = {
      fechaDesde: this.state.fechaDesde,
      fechaHasta: this.state.fechaHasta,
    };

    this.props
      .updateCertificacionTraspaso({
        variables: {
          _id: this.state.certificacion._id,
          nuevaCertificacionTraspaso: objUpdate,
        },
      })
      .then(res => {
        // console.log('res editar', res);
        this.setState(
          {
            ...this.state,
            loading: false,
          },
          () =>
            this.props.history.push(
              `/rrhh/traspaso/${this.state.certificacion.traspaso._id}/precargar`
            )
        );

        notification.success({
          message: 'Certificacion Editada con exito',
          description: 'Se ha registrado los nuevos datos de la certificacion.',
        });
      })
      .catch(err => {
        console.log('Error al editar la certificacion');
        console.log(err);

        Modal.error({
          title: 'Error al editar la certificacion',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    const { certificacion } = this.state;

    return (
      <div>
        <h2 style={{ textAlign: 'center', marginTop: 20, marginBottom: 100 }}>
          Editar Certificacion
        </h2>
        <Form encType="multipart/form-data" onSubmit={this.handleSubmit}>
          <Row>
            <Col span={8} style={{ margin: 'auto' }}>
              <div className="inputs">
                <h3>Reemplazante: </h3>
                <Select
                  required
                  showSearch
                  id="reemplazante"
                  placeholder="Seleccione el reemplazante"
                  value={
                    certificacion.reemplazante.nombre +
                    ' ' +
                    certificacion.reemplazante.apellido
                  }
                  disabled={true}
                ></Select>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={8} style={{ margin: 'auto' }}>
              <div className="inputs">
                <h3>Organismo de origen: </h3>
                <Select
                  showSearch
                  id="origen"
                  placeholder="Seleccione el organismo de origen"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  defaultValue={certificacion.origen.nombre}
                  disabled={true}
                ></Select>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={8} style={{ margin: 'auto' }}>
              <div className="inputs">
                <h3>Organismo destino: </h3>
                <Select
                  showSearch
                  id="destino"
                  placeholder="Seleccione el organismo de destino"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  value={certificacion.destino.nombre}
                  disabled={true}
                ></Select>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={8} style={{ margin: 'auto' }}>
              <div className="inputs">
                <h3>Fecha desde: </h3>
                <DatePicker
                  showTime={{
                    minuteStep: 10,
                    format: 'HH:mm',
                  }}
                  format="DD-MM-YYYY HH:mm"
                  placeholder="Seleccionar Fecha y Hora"
                  style={{ color: '#000000', width: 270 }}
                  defaultValue={this.state.fechaDesde}
                  onChange={fecha => {
                    this.setState({
                      ...this.state,
                      fechaDesde: moment(fecha),
                    });
                  }}
                  disabledDate={fecha => {
                    return (
                      fecha && fecha < moment(certificacion.traspaso.fechaReal)
                    );
                  }}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={8} style={{ margin: 'auto' }}>
              <div className="inputs">
                <h3>Fecha hasta: </h3>
                <DatePicker
                  showTime={{
                    minuteStep: 10,
                    format: 'HH:mm',
                  }}
                  format="DD-MM-YYYY HH:mm"
                  placeholder="Seleccionar Fecha y Hora"
                  style={{ color: '#000000', width: 270 }}
                  defaultValue={this.state.fechaHasta}
                  onChange={fecha => {
                    this.setState({
                      ...this.state,
                      fechaHasta: moment(fecha),
                    });
                  }}
                  disabledDate={fecha => {
                    return fecha && fecha < this.state.fechaDesde;
                  }}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={8} style={{ margin: 'auto' }}>
              <div className="inputs">
                <h3>Normativa: </h3>
                <Input
                  required
                  id="normativa"
                  value={this.state.normativa}
                  placeholder="Complete con la normativa"
                  onChange={e =>
                    this.setState({
                      ...this.state,
                      normativa: e.target.value,
                    })
                  }
                  disabled={true}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={8} style={{ margin: 'auto' }}>
              <div className="inputs">
                <h3>Pago viáticos: </h3>
                <Checkbox
                  id="viaticos"
                  checked={this.state.pagoViaticos}
                  onChange={e => {
                    this.setState({
                      ...this.state,
                      pagoViaticos: e.target.checked,
                    });
                  }}
                  disabled={true}
                />
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: 50, marginBottom: 20 }}>
            <Col style={{ margin: 'auto' }}>
              <Button type="primary" htmlType="submit">
                Guardar
              </Button>
              <Button
                style={{ marginLeft: 20 }}
                type="danger"
                onClick={() => this.props.history.goBack()}
              >
                Atras
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}

export default withApollo(EditarCertificacionTraspaso);
